import { memo } from 'react';
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';
import clsx from 'clsx';

import { getCourseColor } from '../utils/courseColor';

const StaticCourseBox = memo(({
    code,
    section,
    room,
    start,
    end,
    dates,
    instructor,
    hasConflict = false,
    reason,
}) => {
    const roomShort = (room || 'TBA')
        .replace(/, Lift [0-9]+((-|,)( )*[0-9]+)?/gi, '')
        .replace(/\([0-9]+\)/gi, '')
        .replace(/Lecture Theater /gi, 'LT')
        .replace(/, [A-Z ]+/gi, '');
    const tooltipLines = [
        dates?.start && dates?.end ? `${dates.start} - ${dates.end}` : null,
        start && end ? `${start} - ${end}` : null,
        reason,
        room || 'TBA',
        instructor?.length ? `Instructor: ${instructor.join(', ')}` : null,
    ].filter(Boolean);

    return (
        <Tippy content={<div style={{ whiteSpace: 'pre-line' }}>{tooltipLines.join('\n')}</div>} placement="right" offset={[5, 15]}>
            <div className={clsx('lesson', `color${getCourseColor(code)}`, { 'time-conflict': hasConflict })}>
                <div>{code}<br />{section}<br />{roomShort}</div>
            </div>
        </Tippy>
    );
});

export default StaticCourseBox;
